import { Langcode } from '#graphql-operations'

/**
 * Return the current langcode enum for GraphQL requests.
 */
export default function (): ComputedRef<Langcode> {
  const language = useCurrentLanguage()

  return computed(() => {
    if (language.value === 'fr') {
      return Langcode.FR
    } else if (language.value === 'en') {
      return Langcode.EN
    } else if (language.value === 'it') {
      return Langcode.IT
    } else if (language.value === 'es') {
      return Langcode.ES
    }

    return Langcode.DE
  })
}
